import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 21V3H3v18h18zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
}), 'ImageSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ImageSharp.js
// module id = 4218
// module chunks = 2